import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";

export const Route = createFileRoute("/polityka-prywatnosci")({
  component: PrivacyPolicy,
  head: () => ({
    meta: [
      { title: "Polityka prywatności — SkuteczneStrony" },
      {
        name: "description",
        content:
          "Polityka prywatności i informacja RODO serwisu SkuteczneStrony — zakres przetwarzania danych, podstawy prawne, prawa użytkownika i kontakt do administratora.",
      },
      { property: "og:title", content: "Polityka prywatności — SkuteczneStrony" },
      {
        property: "og:description",
        content:
          "Pełna informacja RODO: jakie dane zbieramy, w jakim celu, przez jaki czas i jak możesz z nich korzystać.",
      },
      { property: "og:url", content: "https://skutecznestrony.com/polityka-prywatnosci" },
      { property: "og:type", content: "article" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://skutecznestrony.com/polityka-prywatnosci" }],
  }),
});

function PrivacyPolicy() {
  return (
    <LegalLayout title="Polityka prywatności" updated="23 czerwca 2026">
      <p>
        Niniejsza Polityka prywatności opisuje zasady przetwarzania danych osobowych
        w serwisie internetowym dostępnym pod adresem{" "}
        <strong>https://skutecznestrony.com</strong> (dalej: „Serwis") i stanowi spełnienie obowiązku
        informacyjnego, o którym mowa w art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE)
        2016/679 z dnia 27 kwietnia 2016 r. (RODO).
      </p>

      <h2>1. Administrator danych</h2>
      <p>
        Administratorem danych osobowych przekazywanych przez Serwis jest
        <strong> SkuteczneStrony</strong> (dalej: „Administrator"). Kontakt z Administratorem:
        e-mail <a href="mailto:kontakt@skutecznestrony.com">kontakt@skutecznestrony.com</a>.
      </p>
      <p>
        Jeżeli wymagasz pełnych danych rejestrowych (np. do umowy powierzenia przetwarzania danych),
        skontaktuj się z nami mailowo — udostępnimy je niezwłocznie.
      </p>

      <h2>2. Jakie dane zbieramy</h2>
      <p>W zależności od interakcji z Serwisem przetwarzamy:</p>
      <ul>
        <li>
          <strong>Dane z formularza kontaktowego:</strong> imię lub nazwę firmy, numer telefonu,
          adres e-mail oraz treść wiadomości.
        </li>
        <li>
          <strong>Dane techniczne:</strong> adres IP, typ przeglądarki, system operacyjny,
          przybliżona lokalizacja, źródło wejścia oraz dane zachowania (anonimowe statystyki).
        </li>
        <li>
          <strong>Korespondencja:</strong> treść wiadomości e-mail kierowanych do nas oraz dane
          kontaktowe zawarte w stopkach.
        </li>
      </ul>

      <h2>3. Cele i podstawy prawne przetwarzania</h2>
      <ul>
        <li>
          <strong>Kontakt zwrotny i obsługa zapytania ofertowego</strong> — art. 6 ust. 1 lit. b
          RODO (działania zmierzające do zawarcia umowy) oraz art. 6 ust. 1 lit. f RODO (prawnie
          uzasadniony interes Administratora w prowadzeniu komunikacji z klientami).
        </li>
        <li>
          <strong>Wystawianie dokumentów księgowych</strong> — art. 6 ust. 1 lit. c RODO (obowiązek
          prawny wynikający z ustawy o rachunkowości i przepisów podatkowych).
        </li>
        <li>
          <strong>Statystyka i poprawa działania Serwisu</strong> — art. 6 ust. 1 lit. f RODO
          (prawnie uzasadniony interes).
        </li>
        <li>
          <strong>Marketing własnych usług</strong> — art. 6 ust. 1 lit. f RODO; w przypadku
          komunikacji elektronicznej dodatkowo zgoda (art. 10 ustawy o świadczeniu usług drogą
          elektroniczną oraz art. 172 Prawa telekomunikacyjnego).
        </li>
      </ul>

      <h2>4. Okres przechowywania danych</h2>
      <ul>
        <li>
          Dane z formularza kontaktowego przechowujemy przez okres niezbędny do udzielenia
          odpowiedzi oraz <strong>maksymalnie 24 miesiące</strong> po ostatnim kontakcie.
        </li>
        <li>
          Dane związane z zawartą umową przechowujemy przez okres jej trwania i <strong>do 6 lat
          </strong> od jej zakończenia (przedawnienie roszczeń i obowiązki podatkowe).
        </li>
        <li>
          Dane analityczne przechowujemy w postaci zagregowanej, zgodnie z domyślnymi ustawieniami
          dostawcy.
        </li>
      </ul>

      <h2>5. Odbiorcy danych</h2>
      <p>Twoje dane mogą być powierzane wyłącznie zaufanym podmiotom przetwarzającym:</p>
      <ul>
        <li>dostawcom infrastruktury chmurowej i hostingu (m.in. Supabase, Cloudflare),</li>
        <li>dostawcom narzędzi analitycznych (np. Google Analytics) — wyłącznie na podstawie zgody,</li>
        <li>biuru księgowemu oraz kancelariom w zakresie obsługi rozliczeń lub windykacji,</li>
        <li>uprawnionym organom państwowym, gdy obowiązek wynika z przepisów prawa.</li>
      </ul>

      <h2>6. Przekazywanie danych poza EOG</h2>
      <p>
        Część usług, z których korzystamy (np. analityka), może wiązać się z przekazywaniem danych
        poza Europejski Obszar Gospodarczy. Następuje to wyłącznie w oparciu o
        <strong> Standardowe Klauzule Umowne</strong> zatwierdzone przez Komisję Europejską oraz
        dodatkowe środki bezpieczeństwa stosowane przez dostawców (m.in. ramy Data Privacy
        Framework).
      </p>

      <h2>7. Twoje prawa</h2>
      <p>Na podstawie RODO przysługują Ci:</p>
      <ul>
        <li>prawo dostępu do danych oraz uzyskania ich kopii (art. 15),</li>
        <li>prawo do sprostowania danych (art. 16),</li>
        <li>prawo do usunięcia danych — „prawo do bycia zapomnianym" (art. 17),</li>
        <li>prawo do ograniczenia przetwarzania (art. 18),</li>
        <li>prawo do przenoszenia danych (art. 20),</li>
        <li>
          prawo do sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie
          (art. 21),
        </li>
        <li>prawo do cofnięcia zgody w dowolnym momencie (bez wpływu na wcześniejsze przetwarzanie),</li>
        <li>
          prawo do wniesienia skargi do <strong>Prezesa Urzędu Ochrony Danych Osobowych</strong>{" "}
          (ul. Stawki 2, 00-193 Warszawa).
        </li>
      </ul>
      <p>
        W celu realizacji praw skontaktuj się z nami:{" "}
        <a href="mailto:kontakt@skutecznestrony.com">kontakt@skutecznestrony.com</a>.
      </p>

      <h2>8. Dobrowolność podania danych</h2>
      <p>
        Podanie danych w formularzu kontaktowym jest dobrowolne, lecz niezbędne do udzielenia
        odpowiedzi na zapytanie. Brak podania danych uniemożliwi nam kontakt zwrotny.
      </p>

      <h2>9. Profilowanie i decyzje zautomatyzowane</h2>
      <p>
        Administrator nie podejmuje wobec użytkowników Serwisu decyzji opartych wyłącznie
        na zautomatyzowanym przetwarzaniu danych, które wywoływałyby skutki prawne.
      </p>

      <h2>10. Bezpieczeństwo danych</h2>
      <p>
        Stosujemy środki techniczne i organizacyjne odpowiadające ryzyku, w szczególności:
        szyfrowanie transmisji (TLS/HTTPS), kontrolę dostępu opartą o role (RLS), kopie zapasowe,
        monitoring oraz polityki haseł.
      </p>

      <h2>11. Zmiany w Polityce prywatności</h2>
      <p>
        Polityka może być aktualizowana. Każda zmiana zostanie opublikowana na tej stronie wraz
        z datą obowiązywania. W przypadku istotnych zmian poinformujemy klientów drogą e-mailową.
      </p>

      <p>
        Zasady stosowania plików cookie opisaliśmy w odrębnym dokumencie:{" "}
        <a href="/cookies">Polityka cookies</a>.
      </p>
    </LegalLayout>
  );
}
